import { type FC } from 'react';

import { Input } from '../../../Input';
import { getBaseInputProps } from '../../utils';
import { type CustomWidgetProps } from '../types';

export const TextWidget: FC<CustomWidgetProps> = (props) => <Input {...getBaseInputProps(props)} type="text" />;
